import { render, staticRenderFns } from "./code-editor.vue?vue&type=template&id=d2b95c50&"
import script from "./code-editor.vue?vue&type=script&lang=ts&"
export * from "./code-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports